package com.karyadina.cloudsync.model

import kotlinx.serialization.Serializable

/**
 * Shared Link for collaboration
 * One-time use with 30-minute expiry
 */
@Serializable
data class SharedLink(
    val id: String,
    val creatorId: String,
    val creatorName: String = "",
    val targetId: String,
    val targetType: String, // "note" or "task"
    val targetTitle: String = "",
    val accessToken: String,
    val expiresAt: Long, // milliseconds
    val createdAt: Long,
    val used: Boolean = false, // one-time use flag
    val usedAt: Long = 0L
)

/**
 * Shared content wrapper
 */
@Serializable
data class SharedContent(
    val link: SharedLink,
    val content: String, // JSON-serialized note/task content
    val contentSize: Long
)
